import KanbanCardBody from './KanbanCardBody';
import SortableKanbanCard from './SortableKanbanCard';
import type { KanbanCardProps } from './types';

export type { KanbanCardProps, KanbanRelatedTasksTarget } from './types';
export { isOverdueTask } from './helpers';

const KanbanCard = ({ task, onOpen, onShowRelatedTasks, overlay = false }: KanbanCardProps) => {
    if (overlay) {
        return (
            <KanbanCardBody
                task={task}
                onOpen={onOpen}
                onShowRelatedTasks={onShowRelatedTasks}
                className="task-kanban-card--overlay"
            />
        );
    }

    return (
        <SortableKanbanCard
            task={task}
            onOpen={onOpen}
            onShowRelatedTasks={onShowRelatedTasks}
        />
    );
};

export default KanbanCard;
